import { SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import { Theme } from '@radix-ui/themes';
import mixpanel from 'mixpanel-browser';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { ChooseOrganization, RequestAccess } from '~/components/LoginActionElements';
import { Container, FullscreenWrapper, Logo } from '~/components/LoginElements';
import { DEFAULT_PRIVATE_PATH } from '~/containers/Routes/Routes';
import useAuthentication from '~/hooks/use-authentication';
import useTrackPageView from '~/hooks/use-track-page-view';

export const CLERK_SIGN_IN_VARIABLES = {
  spacingUnit: '12px',
  borderRadius: '4px',
  fontWeight: { bold: 400 },
};

function Login() {
  const theme = useTheme();
  useTrackPageView('Log In');
  const {
    isLoading,
    isLoggedIn,
    usersCurrentOrganizationId,
    usersOrganizations,
    selectedOrganization,
    userId,
    clerkId,
    accessLevel,
  } = useAuthentication();
  const history = useHistory();

  if (isLoading) {
    return null;
  }

  if (isLoggedIn && usersCurrentOrganizationId) {
    mixpanel.track('Login', {
      'Organization Name': selectedOrganization,
      organization_id: usersCurrentOrganizationId,
      distinct_id: userId,
      'Login by switching org': false,
      clerk_id: clerkId,
      // in mixpanel User Type is accessLevel
      'User Type': accessLevel,
    });
    const redirect = localStorage.getItem('redirect');
    if (!redirect) return history.replace(DEFAULT_PRIVATE_PATH);

    history.replace(redirect);
    // The double render React does, causes the redirect to be removed too soon
    return setTimeout(() => {
      localStorage.removeItem('redirect');
    }, 1000);
  }

  return (
    <>
      <SignedOut>
        <Theme appearance='light'>
          <FullscreenWrapper>
            <Container>
              <Logo src={require('~/assets/graphics/onomondo-logo-type-negative.svg')} />
              <SignIn
                signUpUrl={process.env.ONOMONDO_WEBSITE_SIGN_UP_LINK}
                appearance={{
                  variables: {
                    ...CLERK_SIGN_IN_VARIABLES,
                    colorPrimary: theme.darkest,
                  },
                }}
              />
            </Container>
          </FullscreenWrapper>
        </Theme>
      </SignedOut>
      <SignedIn>
        {usersOrganizations.length > 0 ? (
          <ChooseOrganization />
        ) : (
          <Theme appearance='light'>
            <RequestAccess />
          </Theme>
        )}
      </SignedIn>
    </>
  );
}

export default Login;
